import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';

import FONTS from '@mlb/react-patterns/style/fonts';
import { ContentWrapper } from '@mlb/react-patterns/components/AnimatedModal/animatedModal.style.tsx';

import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';
import { Tracking } from 'bdvp-tracking';
import { getMediaPath } from '../../utils';

import { useKeyPress } from '../../hooks';
import { keyConstants } from '../../utils';
import ModalContainer from '../../containers/Modal';
import Url from './Url';
import EmbedCode from './EmbedCode';
import SocialList from './SocialList';

const { SHARE_MODAL_NAME } = modalConstants;
const { TAB } = keyConstants;
const keysToTrack = [TAB];

export const ModalOverride = styled(ModalContainer)`
    &&& {
        height: auto;
        top: 50%;
        left: 50%;
        border-radius: 6px;
        transform: translate(-50%, -50%);
        font-family: ${FONTS.primaryFont};
        ${ContentWrapper} {
            padding: 12px 20px;
        }
    }
`;

export const onShare = ({
    type,
    contentType,
    slug,
    title,
}) => {

    Tracking.onShare({
        type,
        contentType,
        slug,
        title,
    });

};

const ShareModal = ({
    basePath,
    mediaPlayback,
    config,
    dictionary,
    lang,
}) => {

    const firstFocusedNode = React.useRef(null);
    const firstModalNode = React.useRef(null);
    const lastModalNode = React.useRef(null);
    const keyPressCallbackProps = {
        cb: (event) => {

            if (event.target === lastModalNode.current) {

                event.preventDefault();
                firstModalNode.current.focus();

            }

        },
        shiftCB: (event) => {

            if (event.target === firstModalNode.current) {

                event.preventDefault();
                lastModalNode.current.focus();

            }

        },
    };

    useKeyPress(keysToTrack, keyPressCallbackProps);

    const origin = __CLIENT__ ? window.location.origin : 'https://www.mlb.com';
    const mediaPath = getMediaPath(mediaPlayback);
    const link = `${origin}${basePath}/${mediaPath}`;

    return (
        <ModalOverride
            closeButtonRef={firstModalNode}
            name={SHARE_MODAL_NAME}
            headerTitle={_get(dictionary, 'share_video_text', 'Share this Video')}
            width={'320px'}
            overlay={true}
            handlers={{
                onOpened: () => {

                    firstFocusedNode.current.firstElementChild.focus();

                },
                onClosed: () => {

                    Tracking.trackShareModalCloseButtonClick(_get(mediaPlayback, 'slug', ''));

                },
            }}
        >
            <SocialList
                firstFocusedNode={firstFocusedNode}
                mediaPlayback={mediaPlayback}
                link={link}
                config={config}
                dictionary={dictionary}
                lang={lang}
                onShare={onShare}
            />
            <Url
                link={link}
                dictionary={dictionary}
                onShare={onShare}
                mediaPlayback={mediaPlayback}
            />
            <EmbedCode
                lastModalNode={lastModalNode}
                mediaPlayback={mediaPlayback}
                config={config}
                dictionary={dictionary}
                onShare={onShare}
            />
        </ModalOverride>
    );

};

ShareModal.propTypes = {
    basePath: PropTypes.string.isRequired,
    mediaPlayback: PropTypes.shape(),
    config: PropTypes.shape(),
    dictionary: PropTypes.shape(),
    lang: PropTypes.string,
};

ShareModal.defaultProps = {
    mediaPlayback: {},
    config: {},
    dictionary: {},
    lang: 'en',
};

export default ShareModal;
